module.exports = __webpack_public_path__ + "img/Dantam Hair 55.4c4280ae.jpg";